import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { SortDirection } from '@ag-grid-community/core';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, signal } from '@angular/core';
import { SIGNAL } from '@angular/core/primitives/signals';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';

import { AgHeaderLinkComponentParams } from '@shared/ag-components/ag-header-link/ag-header-link.model';
import { Flags, LaunchDarklyService } from '@shared/services/launch-darkly.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `,
  ],
  templateUrl: 'ag-header-link.component.html',
})
export class AgHeaderLinkComponent implements IHeaderAngularComp {
  private readonly destroyRef = inject(DestroyRef);
  private launchDarklyService = inject(LaunchDarklyService);
  private router = inject(Router);

  currentSort = signal<SortDirection>(null);

  cellClass!: string;
  params!: AgHeaderLinkComponentParams;
  showAsLink!: (() => boolean) & { [SIGNAL]: unknown };
  value!: string;

  agInit(params: AgHeaderLinkComponentParams): void {
    this.params = params;
    this.currentSort.set(params.column.getSort() || null);

    if (params.featureFlag) {
      this.showAsLink = this.launchDarklyService.$select(
        (flags) => !!flags[params.featureFlag as keyof Flags]
      );
    } else {
      this.showAsLink = signal(true);
    }

    if (params.sortChanged$) {
      params.sortChanged$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
        this.currentSort.set(params.column.getSort() || null);
      });
    }
  }

  onLinkClicked(event: MouseEvent): void {
    if (this.showAsLink()) {
      event.stopPropagation();

      if (this.params.redirectFunction) {
        this.params.redirectFunction();
      } else if (this.params.link) {
        void this.router.navigate([this.params.link]);
      }
    }
  }

  refresh(): boolean {
    return false;
  }

  toggleSort() {
    if (!this.params.enableSorting) {
      return;
    }

    switch (this.currentSort()) {
      case 'asc':
        this.currentSort.set('desc');
        break;
      case 'desc':
        this.currentSort.set(null);
        break;
      default:
        this.currentSort.set('asc');
    }

    this.params.setSort(this.currentSort());
  }
}
